import styled from 'styled-components';
import * as Styles from '../../utils/styleUtils';

export const StyledDropDown = styled.div`
  ${Styles.SizeStyles}
  box-sizing: border-box;
  padding: ${({ renderMode }) => (renderMode === 'mobile' ? '4px 8px' : '2px 4px')};
  display: flex;
  align-items: center;
  position: relative; /* For the arrow */

  /* Apply all font and border styles from the model */
  ${Styles.FontStyles}
  ${Styles.BorderStyles}

  /* Add the custom arrow */
  &::after {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-right: 1px solid #333;
    border-bottom: 1px solid #333;
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-60%) rotate(45deg);
  }
`;